import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { format } from '@/@core/utils/string';
import { Symbols } from '../../symbols';
import { toRegion } from '../../@helper/CommonHelper';
let MiscApi = class MiscApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.postOrderVolumeBatch = (params) => {
            return this.http.post({
                url: this.urls.postOrderVolumeBatch,
                data: params,
            });
        };
        this.postSalesforceSynchronize = (company_id) => {
            const url = format(this.urls.postSalesforceSynchronize, {
                company_id,
            });
            return this.http.post({
                url,
            });
        };
        this.postChargeModeCompute = (company_id) => {
            const url = format(this.urls.postChargeModeCompute, {
                company_id,
            });
            return this.http.post({
                url,
            });
        };
        this.getWhiteLabel = () => {
            return this.getSystemCodes('WHITE_LABEL');
        };
    }
    getInit() {
        const url = this.urls.getInit;
        return this.http.get({ url }).then(res => {
            return {
                ...res,
                region: toRegion(res.region),
            };
        });
    }
    postCommonRegion(region) {
        const url = format(this.urls.postCommonRegion, {
            region: encodeURIComponent(region),
        });
        return this.http.post({ url });
    }
    getOrderVolumeStats(company_id, params) {
        const url = format(this.urls.getOrderVolumeStats, {
            company_id,
        });
        return this.http.get({ url, params });
    }
    getSystemCodes(type) {
        const url = format(this.urls.getSystemCodes, {
            type,
        });
        return this.http.get({ url });
    }
    /**
     * 查询天眼查公司信息
     */
    getCompanyInfoByTyc(params) {
        const url = this.urls.getCompanyInfoByTyc;
        return this.http.get({
            url,
            params,
        });
    }
    getJobRoles() {
        return this.getSystemCodes('JOB_ROLE');
    }
    // 资源服务器
    getClientResourceServers() {
        return this.getSystemCodes('CLIENT_RESOURCE_SERVERS');
    }
    // 客户端类别
    getClientType() {
        return this.getSystemCodes('CLIENT_TYPE');
    }
    // 客户端权限范围
    getClientScopes() {
        return this.getSystemCodes('CLIENT_SCOPES');
    }
    // 授权类别
    getClientAllowedGrantTypes() {
        return this.getSystemCodes('CLIENT_ALLOWED_GRANT_TYPES');
    }
};
MiscApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.MiscApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], MiscApi);
export { MiscApi };
